import React from 'react';
import { Mail, Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-500 py-10 px-4 border-t border-brand-accent/20" data-id="element-87">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-88">
        <div className="inline-block bg-brand-accent text-white font-bold px-3 py-1 rounded-full mb-4 text-xs tracking-wider" data-id="element-89">
          🌾 KIT PROFE™
        </div>

        <p className="text-base md:text-lg font-medium mb-3 max-w-xl text-gray-300" data-id="element-90">
          El sistema de materiales N°1 para docentes de Historia Agraria en
          escuelas secundarias rurales y técnicas de Argentina.
        </p>

        <p className="text-sm mb-6 italic max-w-lg text-gray-600" data-id="element-91">
          Porque enseñar la historia del campo argentino no debería costarte
          todos los domingos del año.
        </p>

        <div className="flex flex-col md:flex-row gap-3 md:gap-6 mb-8 text-sm" data-id="element-92">
          <a href="mailto:kitonline27@gmail.com" className="flex items-center hover:text-brand-accent transition-colors" data-id="element-93">
            <Mail className="w-4 h-4 mr-2" data-id="element-94" />
            kitonline27@gmail.com
          </a>
          <a href="#" className="flex items-center hover:text-brand-accent transition-colors" data-id="element-95">
            <Instagram className="w-4 h-4 mr-2" data-id="element-96" />
            @kitprofe
          </a>
        </div>

        <div className="w-full border-t border-white/5 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-97">
          <p data-id="element-98">© KIT PROFE™ 2026 — Todos los derechos reservados.</p>
          <p className="mt-2 md:mt-0" data-id="element-99">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <p className="mt-6 text-brand-accent font-bold text-sm md:text-base neon-glow" data-id="element-100">
          🌾 "Tu próximo domingo puede ser diferente."
        </p>
      </div>
    </footer>;
}